import { XCircleFill } from 'react-bootstrap-icons'
import { Portal } from '../Portal'
import { Container, Content, Header, Overlay } from './styles'
import { useEffect } from 'react'

export function Modable({ isOpen, onClose, title, children, size }) {
  useEffect(() => {
    function handlePressEsc(e) {
      if (e.key === 'Escape') {
        onClose()
      }
    }

    document.addEventListener('keydown', handlePressEsc)

    return () => {
      document.removeEventListener('keydown', handlePressEsc)
    }
  }, [onClose])

  return (
    <Portal isOpen={isOpen}>
      <Overlay>
        <Container size={size}>
          <Header>
            {title && <h1>{title}</h1>}

            <button onClick={onClose}>
              <XCircleFill
                size={25}
                color="#c0392b"
              />
            </button>
          </Header>

          <Content>{children}</Content>
        </Container>
      </Overlay>
    </Portal>
  )
}
